import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import {
  pointsService,
  RewardPointsResponse,
  RewardPointsRequest,
  TransferPointsRequest,
  TransferPointsResponse,
} from '@aslanpay/portal-common-lib';

const useRewardPoints = ({
  onSuccess,
  onError,
}: UseMutationOptions<RewardPointsResponse, Error, RewardPointsRequest>) => {
  return useMutation<RewardPointsResponse, Error, RewardPointsRequest>(
    ({
      individualIds,
      transactionReason,
      pointsAmount,
      notes,
      companyId,
      referralId,
      merchantClickId,
      labelId,
    }: RewardPointsRequest) =>
      pointsService.rewardPoints({
        individualIds,
        transactionReason,
        pointsAmount,
        notes,
        companyId,
        referralId,
        merchantClickId,
        labelId,
      }),
    { onSuccess, onError }
  );
};

const useTransferPoints = ({
  onSuccess,
  onError,
  ...rest
}: UseMutationOptions<TransferPointsResponse, Error, TransferPointsRequest>) => {
  const queryClient = useQueryClient();

  return useMutation<TransferPointsResponse, Error, TransferPointsRequest>(
    (props: TransferPointsRequest) => pointsService.transferPoints(props),
    {
      ...rest,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: ['fetchPots'] });
        queryClient.invalidateQueries({ queryKey: ['fetchPointsTransactions'] });
        onSuccess?.(data, variables, context);
      },
      onError,
    }
  );
};

const usePoints = {
  useRewardPoints,
  useTransferPoints,
};

export default usePoints;
